import React, { useCallback, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import NumericInput from 'react-numeric-input';
import { initialAuthenicate } from './auth/ducks/auth';
import moment  from 'moment';
import { useMemo } from 'react';
import { useMutation } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { toast } from 'react-toastify';


const year = moment().format('YYYY');

const initialState = {
    name:'',
    grade:0,
    schoolClass:0,
    privacy:'',
    stage:'input'
};

function stanbyReducer (state, action) {
    return {...state, ...action };
};

const UserStanBy = ()=>{
    const dispatch = useDispatch();
    const [state, setState] = useReducer(stanbyReducer, initialState);

    const startMutate = useMutation({
        mutationFn:(data)=>Api.post('/api/user/stanby', data),
        onSuccess:(res)=>{
            setState({'stage':'badge'});
        },
        onError:(err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    });

    const onStore = useCallback((e) => {
        //form submit event
        e.preventDefault();
        if(state.grade===0 || state.schoolClass===0){
            alert('학년 반은 1이상으로 입력해주세요.');
            return;
        }

        if (state.privacy === '') {
            alert('이용약관, 개인정보처리방침에 동의해주세요.');
            return;
        }

        const updateData = { name:state.name, grade:state.grade, schoolClass:state.schoolClass };

        if ( !window.confirm("저장하시겠습니까?") ) return;

        startMutate.mutate(updateData);

    }, [startMutate, state.grade, state.name, state.privacy, state.schoolClass]);

    const contents = useMemo(()=>{
        if(state.stage==='input'){
            return (
                <form className='form' onSubmit={onStore}>
                    <div className="row">
                        <h4>별명 또는 이름</h4>
                        <input type="text" id="name" autoComplete="off" maxLength={7} placeholder="별명 또는 이름을 입력해주세요." value={state.name} onChange={(e) => {setState({'name':e.target.value})}} required />
                    </div>
                    <div className="row grid_row">
                        <div>
                            <h4>학년</h4>
                            <NumericInput value={state.grade} strict={true} min={0} max={7} onChange={(value) => {setState({'grade':value})}} required />
                        </div>
                        <div>
                            <h4>반</h4>
                            <NumericInput value={state.schoolClass} strict={true} min={0} max={20} onChange={(value) => {setState({'schoolClass':value}); console.log(value);}} required />
                        </div>
                    </div>
                    <div className="row">
                        <h4>약관 동의</h4>
                        <div className="input_check">
                            <input type="checkbox" id="privacyY" checked={state.privacy==='Y'} onChange={(e)=>setState({'privacy':e.target.checked ? 'Y':''})} /><label htmlFor="privacyY">이용약관&middot;개인정보처리방침에 동의합니다.</label>
                        </div>
                    </div>
                    <button type="submit" className="press_btn" ><span>수정하기</span></button>
                </form>
            );
        }

        // input이 아닐때는 badge 밖에 없고
        // 새로운 시작 뱃지를 보여주고 독서길라잡이를 시작
        return (
            <div className='form' >
                <div className="thumb">
                    <div className="badge_bg"></div>
                    <img src={`${process.env.PUBLIC_URL}/static/images/user/user_stanby_badge.png`} alt="독서 입문자"/>
                </div>
                <h4 className="modal_title"><span>{year} 독서등급</span> 이 새로 시작됩니다!</h4>
                <p className="modal_desc">새해가 되면 독서길라잡이 친구들의 독서 등급은<br/>독서 입문자로 되돌아갑니다.</p>
                <button type="button" className="press_btn" onClick={e => dispatch( initialAuthenicate() )}><span>독서길라잡이 시작하기</span></button>
            </div>
        )
    }, [state.stage, state.name, state.grade, state.schoolClass, state.privacy, onStore, dispatch]);

    return (
        <div className="user_stanby">
            <div className={`container ${state.stage === 'badge' ? 'badge_container' : ''}`}>
                <h2 className="user_stanby_title"><span>{year}</span><br/>독서길라잡이</h2>
                <p className="user_stanby_desc">올 한 해 사용할 새로운 이름과 학년, 반을 등록해주세요.</p>
                <div className="contents">
                    {contents}
                </div>
            </div>
        </div>
    )
}
export default UserStanBy;